import { breakpoint } from '@bizneo/core/utils';
import parse from 'date-fns/parse';
import set from 'date-fns/set';

const $tmpl = $(
  '<div id="news-panel"><i class="huge-icon is-xsmall huge-cancel-01 close-news" data-toggle-news-panel></i></div>'
);
const SELECTOR = '[data-news-wrapper]';
const BTN_SELECTOR = '[data-toggle-news-panel]';
const PANEL = '#news-panel';

function togglePanel(iframe_url) {
  if (!$(PANEL).find('iframe').length) {
    $(SELECTOR).append($tmpl.append(`<iframe src="${iframe_url}" frameborder="0"></iframe>`));
  }
  $('body').toggleClass('opened-news');
}

function openByReleaseNumber(releaseNumber, iframe_url) {
  const notifications = localStorage.getItem('notifications');

  if (notifications === null || +notifications !== releaseNumber) {
    togglePanel(iframe_url);
  }
}

function openByDate(newsDate, iframe_url) {
  const today = set(new Date(), { hours: 0, minutes: 0, seconds: 0, milliseconds: 0 });
  const expiration = localStorage.getItem('notifications');
  const publicationDate = parse(newsDate, 'yyyy-MM-dd', new Date());
  const expirationDate = parse(expiration, 'yyyy-MM-dd', new Date());

  if (!expiration || (publicationDate > expirationDate && today >= publicationDate)) {
    togglePanel(iframe_url);
  }
}

$(document).on('dom-update', e => {
  const $wrapper = $(e.target).find(SELECTOR);
  breakpoint.refresh();

  if (breakpoint.value === 'mobile' || !$wrapper.length) return;

  const { newsDate, newsUrl, newsRelease } = $wrapper.data();
  if (newsRelease) openByReleaseNumber(newsRelease, newsUrl);
  if (newsDate) openByDate(newsDate, newsUrl);
});

$(document).on('click', BTN_SELECTOR, e => {
  const { newsDate, newsUrl, newsRelease } = $(SELECTOR).data();
  e.preventDefault();
  togglePanel(newsUrl);
  if (newsRelease) localStorage.setItem('notifications', newsRelease);
  if (newsDate) localStorage.setItem('notifications', newsDate);
  $(BTN_SELECTOR).removeClass('active');
});
